import { render } from "./SwisstopoSearch.vue?vue&type=template&id=412d46e9"
import script from "./SwisstopoSearch.vue?vue&type=script&lang=js"
export * from "./SwisstopoSearch.vue?vue&type=script&lang=js"

import "./SwisstopoSearch.vue?vue&type=style&index=0&id=412d46e9&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__